import createElement from "./createElement";
import {randomUniqueClassName} from "./random";


//TODO: Clean up this, move then to their own file on /inputs

/**
 * Comes from https://getdatepicker.com/4/Options/
 */


export function setAsDateField(elementOrSelector, settings = {}) {
	const defaultSettings = {
		format: 'MM/DD/YYYY',
		icons: {
			time: 'mdi mdi-clock',
			date: 'mdi mdi-calendar-blank',
			up: 'mdi mdi-chevron-up',
			down: 'mdi mdi-chevron-down',
			previous: 'mdi mdi-chevron-left',
			next: 'mdi mdi-chevron-right',
			today: 'mdi mdi-calendar',
			clear: 'mdi mdi-delete',
			close: 'mdi mdi-close'
		},
		wrapperSettings: {
			showClearButton: false,
			showTimezone: false,
		}
	}

	const finalSettings = {
		...defaultSettings,
		...settings,
	}

	const wrapperSettings = finalSettings.wrapperSettings;

	delete finalSettings.wrapperSettings;

	// noinspection JSUnresolvedFunction
	$(elementOrSelector).datetimepicker(finalSettings);

	if (wrapperSettings.showClearButton) {
		addClearButtonToLabel(elementOrSelector);
	}
	if (wrapperSettings.showTimezone) {
		addTimeZoneToInput(elementOrSelector);
	}
}

export function setAsDateAndTimeField(elementOrSelector, settings = {}) {
	const defaultSettings = {
		format: 'MM/DD/YYYY hh:mm A',
		sideBySide: true,
		showClear: true,
		icons: {
			time: 'mdi mdi-clock',
			date: 'mdi mdi-calendar-blank',
			up: 'mdi mdi-chevron-up',
			down: 'mdi mdi-chevron-down',
			previous: 'mdi mdi-chevron-left',
			next: 'mdi mdi-chevron-right',
			today: 'mdi mdi-calendar',
			clear: 'mdi mdi-delete',
			close: 'mdi mdi-close'
		},
		wrapperSettings: {
			showClearButton: true,
			showTimezone: true,
		}
	}

	const finalSettings = {
		...defaultSettings,
		...settings,
	}

	const wrapperSettings = finalSettings.wrapperSettings;

	delete finalSettings.wrapperSettings;

	// noinspection JSUnresolvedFunction
	$(elementOrSelector).datetimepicker(finalSettings);

	if (wrapperSettings.showClearButton) {
		addClearButtonToLabel(elementOrSelector);
	}
	if (wrapperSettings.showTimezone) {
		addTimeZoneToInput(elementOrSelector);
	}
}

export function setAsTimeField(elementOrSelector, settings = {}) {
	const defaultSettings = {
		format: 'hh:mm A',
		showClear: true,
		icons: {
			time: 'mdi mdi-clock',
			date: 'mdi mdi-calendar-blank',
			up: 'mdi mdi-chevron-up',
			down: 'mdi mdi-chevron-down',
			previous: 'mdi mdi-chevron-left',
			next: 'mdi mdi-chevron-right',
			today: 'mdi mdi-calendar',
			clear: 'mdi mdi-delete',
			close: 'mdi mdi-close'
		},
		wrapperSettings: {
			showClearButton: true,
			showTimezone: true,
		}
	}

	const finalSettings = {
		...defaultSettings,
		...settings,
	}

	const wrapperSettings = finalSettings.wrapperSettings;

	delete finalSettings.wrapperSettings;

	// noinspection JSUnresolvedFunction
	$(elementOrSelector).datetimepicker(finalSettings);

	if (wrapperSettings.showClearButton) {
		addClearButtonToLabel(elementOrSelector);
	}
	if (wrapperSettings.showTimezone) {
		addTimeZoneToInput(elementOrSelector);
	}
}

function addClearButtonToLabel(elementOrSelector) {
	const button = createElement(`
        <button type="button" class="btn btn-danger btn-sm ml-2 p-0" style="padding: 2px !important">
            <i class="mdi mdi-close-circle-outline" style="font-size: 1rem" title="Clear"></i>
        </button>
    `);

	button.onclick = () => {
		// noinspection JSUnresolvedFunction
		$(elementOrSelector).data("DateTimePicker").clear();
	}

	const label = $(elementOrSelector).siblings('label')[0];

	if (label) {
		label.appendChild(button);
	}
}

function addTimeZoneToInput(elementOrSelector) {
	const timeZoneLabel = createElement(`
        <div>
            <small class="text-muted">
                Central Daylight Time
            </small>
        </div>
    `);

	$(elementOrSelector).after(timeZoneLabel);
}


export function setAsSelect2(elementOrSelector, settings = {}) {
	let insideModal = false;

	// Check if modal checking is enabled
	if (settings._forModal) {
		// Check if inside a element is inside a modal
		if ($(elementOrSelector).closest('.modal').length) {
			insideModal = true;
		}
	}

	const defaultSettings = {
		allowClear: false,
		theme: 'bootstrap4 flex-grow-1',
		_forModal: false,
	}

	const finalSettings = {
		...defaultSettings,
		...settings,
	}

	if (insideModal) {
		// Make modal dropdown parent
		finalSettings.dropdownParent = $(elementOrSelector).closest('.modal')[0];
	}

	// noinspection JSUnresolvedFunction
	$(elementOrSelector).select2(finalSettings);

	// noinspection JSUnresolvedVariable
	const select2Container = $(elementOrSelector).data('select2').$container[0];

	// Remove title attribute generated by select2
	select2Container.querySelector('.select2-selection__rendered').title = '';

	// Also remove title attribute after a select change
	$(elementOrSelector).on('change', () => {
		select2Container.querySelector('.select2-selection__rendered').title = '';
	})

	// Generate a class name to be used as an Id to connect the actual
	// underlying element with the select2 dropdown
	const select2ClassName = randomUniqueClassName('select2Id_');

	// Add to dropdown
	$(elementOrSelector).data('select2').$dropdown.data('_select2_target', select2ClassName);

	// Add to underlying element
	$(elementOrSelector).addClass(select2ClassName);

	if (insideModal) {
		// May be initialized offscreen so we set its width manually
		$(elementOrSelector).data('select2').$container.addClass('w-100');
	}
}

/**
 * Returns the underlying input or select element a select2 dropdowns points to
 *
 * @param {Node} node
 */
export function getSelect2DropdownTarget(node) {
	// Find container
	const select2Container = $(node).closest('.select2-container');

	// Get Id class
	const targetClass = $(select2Container).data('_select2_target');

	return document.querySelector("." + targetClass);
}
